const MIN_PREVIEW_WIDTH = 400;
const FORM_GAPS = 48;
const FORM_CONTENT_PADDING = 32;

export function computeFormLayout(params: {
  sidebarWidth: number;
  brandKitWidth: number;
  panelWidth: number;
  availableWidth: number;
}): { hasSpaceForInFlow: boolean } {
  const { sidebarWidth, brandKitWidth, panelWidth, availableWidth } = params;
  const neededWidth =
    sidebarWidth + brandKitWidth + MIN_PREVIEW_WIDTH + panelWidth + FORM_GAPS;
  const hasSpaceForInFlow =
    neededWidth <= availableWidth - FORM_CONTENT_PADDING;
  return { hasSpaceForInFlow };
}
